var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-dotlotie-loader"},[_c('div',{staticClass:"anim-container",style:({ paddingTop: _vm.aspectRatio })},[_c('canvas',{staticClass:"anim",attrs:{"id":_vm.domID}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }